<!--
 * @Author: your name
 * @Date: 2020-02-18 10:08:10
 * @LastEditTime: 2020-06-17 22:23:24
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /xkxy_front/src/components/Index.vue
 -->
<template>
  <div class="index" :style="`background: url('${require('../assets/bg21.png')}'); background-size: 100% 100%;`">
    <!-- <img class="sub-logo" src="../assets/logo4.png"> -->
    <img class="sub-logo2" src="../assets/logo5.png">
    <div class="body" v-if="openid">
        <div class="title" @click="goToVideoList(1)">
            <img class="icon" src="../assets/icon0.png" >
            <div class="title-text">政策解读</div>
            <img src="../assets/right.png" class="go">
        </div>
        <div class="title" @click="goToList()">
            <img class="icon" src="../assets/icon1.png" >
            <div class="title-text">医院管理</div>
            <img src="../assets/right.png" class="go">
        </div>
        <div class="title"  @click="goToVideoList3(5)">
            <img class="icon" src="../assets/icon2.png" >
            <div class="title-text">公立医院综合改革</div>
            <img src="../assets/right.png" class="go">
        </div>
        <div class="title boder-bottom"  @click="goToVideoList(10)">
            <img class="icon" src="../assets/icon5.png" >
            <div class="title-text">基层医疗机构能力建设</div>
            <img src="../assets/right.png" class="go">
        </div>
         <div class="title" @click="goToVideoList(18)">
            <img class="icon" src="../assets/icon0.png" >
            <div class="title-text">会议回放</div>
            <img src="../assets/right.png" class="go">
        </div>
        <div class="indexSwipe">
           <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white" :width="334">
              <!-- <van-swipe-item>  
                  <img src="../assets/weiji.png" class="wenJuanImg3" @click="goToVideoList(17)"> 
              </van-swipe-item> 
              <van-swipe-item>  
                  <img src="../assets/zhibo.png" class="wenJuanImg3" @click="openUrl('https://hys.people-health.cn/act/hta/?from=groupmessage&isappinstalled=0#/pages/videos/commonVideo/live?id=7f95e2537add4be1902a53094a48b6fa')"> 
              </van-swipe-item> 
              <van-swipe-item>  
                  <img src="../assets/quyibufang.png" class="wenJuanImg3" @click="goToVideoList(16)"> 
              </van-swipe-item>  -->
              <van-swipe-item v-for="item in carouselList" :key="item.id">  
                  <img :src="item.thumb" class="wenJuanImg3" @click="clickSwipe(item.type, item.variable)"> 
              </van-swipe-item> 
            </van-swipe>
            <!-- <div class="wenJuan"  @click="goToVideoList(1)">
                <img src="../assets/hulian2.png" class="wenJuanImg">
            </div> -->
            <div class="wenJuan"  @click="openUrl('https://www.wjx.cn/jq/67047916.aspx')">
                <img src="../assets/wenjuan.png" class="wenJuanImg">
            </div>

            <!-- <div class="wenJuan"  @click="openUrl('https://hys.people-health.cn/act/hta/#/pages/videos/commonVideo/live?id=7f95e2537add4be1902a53094a48b6fa')">
                <img src="../assets/yantaohui.png" class="wenJuanImg">
            </div> -->
        </div>
       
    </div>

     <div class="var_popup">
        <van-popup v-model="show" class="privacy">
          <div class="title">星空学院隐私条款</div>
          <div class="content">
            <div class="contentInner">
           诚挚欢迎您访问星空学院online学习平台，当您访问时，我们会按照本声明条款收集、使用您的个人信息并予以保护，请您认真、完整阅读本声明。在您点击勾选“我已阅读同意”后，我们将默认您已经认真、完整阅读及同意本声明中的全部内容。
一、我们为什么需要收集、使用您的个人信息
我们收集您的个人信息是为了在遵守国家相关法律法规的前提下，向您提供更优质的服务，提高用户体验，保证网络安全及改进活动内容，为了实现这一总体目的，我们会把您的个人信息用于下列用途：
1.1为了向您提供我们活动中的各项服务及实现相关功能，并维护、改进这些服务和功能。
1.2为了改进活动的服务质量，便于收取您对我们的各种意见和建议，及时有针对性地向您提供反馈或解决方案。
1.3为了系统安全并协助解决您在使用活动服务时可能遇到的相关问题，我们会收集您的个人信息。
1.4我们因业务分析、市场调研需要，会使用到您的个人信息。
二、我们收集、使用您的个人信息的方式
2.1当您访问我们的活动页面，通过互联网获取我们的任一服务，或使用我们活动页面中的某项功能时，您会主动向我们提供个人信息，我们也将会收集您的个人信息。
2.2除非另行书面说明，本声明不适用于我们通过其他方式，如通过非网络的离线方式收集的信息。
三、我们收集和使用您的哪些个人信息
3.1为了向您提供更个性化、更便捷的服务，您可能要根据活动要求主动向我们提供您的相关个人信息，例如您的用户名、性别、城市信息、单位名称、单位性质、职务等。
3.2出于保证系统安全，解决您使用活动服务时可能遇到的相关问题等原因，我们会保存您登录系统的时间、访问的菜单或链接、IP地址、操作日志等信息，并严格按照相关法律法规中的规定对这些信息进行妥善保管。
3.3如果您不同意提供相关的信息，可能导致您的要求或者需要的服务无法满足。
四、与第三方共享信息
根据中国相关法律法规及国家机关的要求。（本声明中的“法律法规”仅指中国现行有效的法律、行政法规、司法解释、地方法规、地方规章、部门规章及其他规范性文件以及对于该等法律法规的不时修改和补充，以及相关政策规定等，下同。为本声明之目的，“中国”一词仅包括中国大陆地区，不包括香港特别行政区、澳门特别行政区和台湾地区。）
五、Cookie及其他技术
我们可能会使用在活动中、及其相关活动上的Cookies应用程序。Cookies应用程序是活动服务器为保存记录而向个人用户的电脑所传递的数据。我们使用Cookies及其他技术是为了使我们的系统能够识别您的设备，从而为您持续访问和使用我们的活动提供便利。
六、IP地址
您的IP地址是指当您使用网络服务器时，自动分配到您正在使用的登陆设备的号码。当您访问我们活动时，该号码及访问时间和访问网页将会被自动识别并记录在我们的服务器日志文件当中。收集IP地址是互联网的惯例并且许多活动会自动进行收集。
七、未成年人保护
我们仅向年满18周岁的人士提供服务。如果您为未成年人，请不要向我们提供个人信息，我们也不建议您参加我们的活动，或使用我们提供的服务。
八、个人信息的安全与保护
我们会对收集的个人信息严格保密。我们亦会采取适当的技术措施和其他必要措施，确保个人信息安全，以防止该个人信息的泄漏和丢失。如您不同意您的个人信息按本隐私声明的规定进行收集和使用，请勿使用我们提供的服务或向我们提供您的个人信息。
九、关于平台内容知识产权
9.1 除本平台中课程内容的知识产权权利外，本平台中提供的任何其他内容（包括但不限于网页、文字、图片、音频、视频、图表等）的知识产权权利（包括但不限于著作权、商标权、专利权等）均归拜耳医药保健公司所有。本平台中课程内容的知识产权权利归作者或其他相关权利人所有。
9.2上述及其他任何本平台包含的内容的知识产权权利均受到法律法规保护，未经拜耳医药保健公司或相关权利人书面许可，任何人不得以任何形式进行转录、使用或基于本平台包含的内容制作相关衍生作品。
            </div>
          </div>
          <van-row class="bottom" type="flex" justify="center">
              <van-checkbox v-model="checked" shape="square" class="agree">我已阅读同意</van-checkbox>
          </van-row>
          <div>
              <van-row class="bottom" type="flex" justify="center">
                  <van-col>
                      <van-button type="primary"  class="cancel" @click="cancelPrivacy()">取消</van-button>
                      <van-button type="info" class="confirm" @click="confirmPrivacy()">确认</van-button>
                  </van-col>
              </van-row>
          </div>
      </van-popup>
      <van-popup v-model="choose" class="choose">
          <div>
              <van-row class="content" type="flex" justify="center">
                  <van-col>
                      <van-button type="primary" class="cancel" @click="goToLogin()">登录</van-button>
                      <van-button type="info" class="confirm" @click="goToRegistered()">注册</van-button>
                  </van-col>
              </van-row>
          </div>
      </van-popup>
      <van-popup v-model="registered" class="registered">
          <div>
              <div class="title">用户注册</div>
                <van-field
                  v-model="name"
                  required
                  label="姓名"
                  :left-icon="require('../assets/user.png')"
                  placeholder="请输入您的姓名"
              />
              <van-field
                  required
                  label="性别"
                  :left-icon="require('../assets/sex.png')">
                  <template #input>
                    <van-radio-group v-model="sex" direction="horizontal">
                      <van-radio name="1">男</van-radio>
                      <van-radio name="2">女</van-radio>
                    </van-radio-group>
                  </template>
              </van-field>
                <van-field
                  v-model="province"
                  required
                  label="省份"
                  :left-icon="require('../assets/province.jpg')"
                  placeholder="请输入您的省份"
              />
              <van-field
                  v-model="city"
                  required
                  label="城市"
                  :left-icon="require('../assets/city.png')"
                  placeholder="请输入您的城市"
              />
                <van-field
                  v-model="mechanism"
                  readonly
                  required
                  label="职务"
                  :left-icon="require('../assets/org.png')"
                  right-icon="arrow"
                  placeholder="请输入您的职务"
                  @click="() => {this.showPicker2 = true}"
              />
              <van-field
                  v-model="unit"
                  readonly
                  required
                  label="单位性质"
                  :left-icon="require('../assets/unit.png')"
                  right-icon="arrow"
                  placeholder="请选择您的单位性质"
                  @click="() => {this.showPicker = true}"
              />
                <van-field
                  v-model="unit_name"
                  required
                  :label="unitNameLable"
                  :left-icon="require('../assets/unit-name.png')"
                  :placeholder="unitNameLableTip"
              />
              <van-row class="bottom" type="flex" justify="center">
                <van-col ><van-button type="info" class="confirm" @click="registeredUser()">注册</van-button></van-col>
              </van-row>
          </div>
      </van-popup>
        <van-popup v-model="showPicker" position="bottom">
        <van-picker
          show-toolbar
          :columns="[
            '医疗卫生行政机关',
            '三级公立医院',
            '二级公立医院及以下',
            '社区卫生服务中心',
            '乡镇卫生院',
            '民营医院',
            'BHC'
          ]"
          @cancel="showPicker = false"
          @confirm="onConfirm"
        />
      </van-popup>

    <van-popup v-model="showPicker2" position="bottom">
        <van-picker
          show-toolbar
          :columns="[
            '院长/副院长/书记',
            '非临床科室管理者',
            '临床科室管理者',
            '其他'
          ]"
          @cancel="showPicker2 = false"
          @confirm="onConfirm2"
        />
      </van-popup>

      <van-popup v-model="statement" class="statement">
          <div class="title">
            <img  src="../assets/head2.png" >
          </div>
          <div class="content">
            <div class="contentInner">
            诚挚欢迎您访问本活动，当您访问我们活动时，我们会按照本隐私声明条款收集、使用您的个人信息并予以保护，请您完整阅读本隐私声明。
          
            <p>一、我们为什么需要收集、使用您的信息</p>
        
              </div>
          </div>
          <div class="bottom">
             <div class="goLine"></div>
             <img class="go" src="../assets/go.png" >
          </div>
      </van-popup>
    </div>
    <share></share>
  </div>
  
  
</template>

<script>
import { Http } from "@/utils/http.js";
import api from "@/config/api.js";
import Cookies from 'js-cookie'

// import { mapActions } from 'vuex'

export default {
  name: 'Index',
  data () {
    return {
      show: false,
      choose: false,
      registered: false,
      login: false,
      checked: false,
      name: '',
      unit_name: '',
      city: '',
      province: '',
      sex: '',
      unit: '',
      mechanism: '',
      repeatClick: false,
      uid: '', // 用户ID
      showPicker: false,
      showPicker2: false,
      statement: false,  //
      openid: '', // 微信ID
      unitNameLable: '单位名称',
      unitNameLableTip: '请输入您的单位名称',
      carouselList: [] //轮播图列表
    }
  },

  methods: {
    // 尚未开放
    noOpen () {
      this.customAlert('敬请期待')
    },
    // 打开心里
    openStatement () {
      this.statement = true
    },
    // 公司性质选择下拉框
    onConfirm (value) {
      this.showPicker = false
      // 如果是BHC 则提示
      if(value == 'BHC'){
        this.unit_name = ''
        this.unitNameLable = 'CWID号'
        this.unitNameLableTip = '请输入您的CWID号'
      } else {
        this.unit_name = ''
        this.unitNameLable = '单位名称'
        this.unitNameLableTip = '请输入您的单位名称'
      }
      this.unit = value
    },
     // 公司职务选择下拉框
    onConfirm2 (value) {
      this.showPicker2 = false
      this.mechanism = value
    },
    // 显示注册选择项
    goToChoose () {
      this.show = true
    },
    // 跳转到视频列表页
    goToVideoList(id){
      if(!this.uid){
        this.goToChoose()
        return 
      }
      this.$router.push({ name: "ListShow", query: { id: id } });
    },
    // 跳转到视频列表页
    goToVideoList3(id){
      if(!this.uid){
        this.goToChoose()
        return 
      }
      this.$router.push({ name: "ListShow3", query: { id: id } });
    },
    // 跳转到二级菜单页
    goToList(){
      if(!this.uid){
        this.goToChoose()
        return 
      }
      this.$router.push({ name: "List" });
    },

     // 跳转到调研的说明页
    goToStatement(){
      if(!this.uid){
        this.goToChoose()
        return 
      }
      this.$router.push({ name: "QuestionList" });
    },

      // 跳转到视频详情页
      goVideoShow (id) {
        if(!this.uid){
          this.goToChoose()
            return 
        }
        this.$router.push({ name: "Show", query: { id: id } })
      },
    // 打开第三方链接页
    openUrl(url){
      if(!this.uid){
          this.goToChoose()
          return 
      }
      window.location.href = url
    },
    // 增加浏览时间
    browseTime() {
      let data = {};
      if(this.uid){
          data.uid = this.uid
          data.type = 3
          // 增加浏览统计时间
          Http.post(api.browseTime, data).then(response => {
              return 
          });
      }
    },
       // 显示隐私
    showPrivacy() {
      this.show = true;
    },
    // 显示选取去登录，还是去注册
    showChoose() {
        this.choose = true;
    },
    // 显示注册
    showRegistered() {
        this.registered = true;
    },
    // 显示登录
    showLogin() {
        this.login = true;
    },
    // 去登录
    goToLogin () {
      this.choose = false
      this.login = true
    },
    // 去注册
    goToRegistered () {
      this.choose = false
      this.show = true
    },
    // 取消隐私
    cancelPrivacy () {
      this.show = false
    },
    // 弹框
    customAlert (msg) {
      this.$dialog.alert({
        message: msg
      })
    },
    // 确认隐私
    confirmPrivacy () {
      // 判断是否点击确认按钮
      if (!this.checked) {
        this.customAlert('请点击隐私确认')
        return 
      }
      this.show = false
      this.registered = true
    },
    // 注册用户
    registeredUser () {
      if (this.repeatClick) {
        this.customAlert('注册中...')
      }
      this.repeatClick = true
      // 判断用户是否所有参数都填了
      this.name = this.name.trim()
      this.city = this.city.trim()
      //this.tel = this.tel.trim()
      this.unit = this.unit.trim()
      this.mechanism = this.mechanism.trim()
      if (!this.name || !this.city || !this.province || !this.unit || !this.mechanism || !this.sex) {
        this.customAlert('所有内容必填')
        this.repeatClick = false
        return false
      }
      if(this.unit != 'BHC' && this.unit_name.length < 5) {
        this.customAlert('单位名称请使用全称')
        this.repeatClick = false
        return false
      }
      if(this.unit == 'BHC'){
          const myreg = /^[A-Za-z]{5}$/
          if (!myreg.test(this.unit_name)) {
            this.customAlert("请输入正确的CWID号码")
            this.repeatClick = false
            return false
          }
      }
      // 注册用户
      let data = {}
      data.openid = this.openid
      data.province = this.province
      data.name = this.name
      data.city = this.city
      data.unit_name = this.unit_name
      data.unit = this.unit
      data.mechanism = this.mechanism
      data.sex = this.sex
      data.openid = this.openid
      Http.post(api.registerUser, data).then(response => {
        this.repeatClick = false
        if (response.code == 1) {
          // 写入返回的cookie 值
          Cookies.set('uid', response.uid, { expires: 730 })
          this.uid = response.uid
          this.customAlert('注册成功')
          this.registered = false
        } else {
          // 发送失败
          this.customAlert(response.msg)
          return false
        }
      })
    },
    // 用户登录
    userLogin () {
      if (this.repeatClick) {
        this.customAlert('登录中...')
      }
      this.repeatClick = true
      // 判断用户是否所有参数都填了
      this.name = this.name.trim()
      // this.tel = this.tel.trim()
      if (!this.name || !this.tel) {
        this.customAlert('所有内容必填')
        this.repeatClick = false
        return false
      }
      // // 判断手机号格式
      // const myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
      // if (!myreg.test(this.tel)) {
      //   this.customAlert("请输入准确的手机号")
      //   this.repeatClick = false
      //   return false
      // }
      // 注册用户
      let data = {}
     // data.tel = this.tel
      data.name = this.name
      Http.post(api.userLogin, data).then(response => {
        this.repeatClick = false
        if (response.code == 1) {
          // 写入返回的cookie 值
          Cookies.set('uid', response.uid, { expires: 730 })
          this.uid = response.uid
          this.customAlert('登录成功')
          this.login = false
        } else {
          // 发送失败
          this.customAlert('登录失败手机号码不对')
          return false
        }
      })
    },
    // 获取轮播图数据
    getCarouselListData() {
      const data = {}
      data.pageSize = 20
      data.pageNum = 1
      Http.post(api.getCarouselList, data).then(res => {
          this.carouselList = res.data
          console.log(this.carouselList)
      })
    },
    // 点击轮播图
    clickSwipe(type, variable) {
      if(type == 1) {
        this.goToVideoList(variable)
      }else{
        this.openUrl(variable)
      }
    }
  },

  mounted: function () {
    // 如果用户ID不存在 则注册
    this.openid = Cookies.get('openid')
    this.uid = Cookies.get('uid')
    if(!this.uid){
      this.name = Cookies.get('nickname')
      this.city = Cookies.get('city')
      this.sex = Cookies.get('sex')
      this.province = Cookies.get('province')
    }
    // 增加浏览时间
    this.browseTime()
    // 获取轮播图列表
    this.getCarouselListData()
  }
}
</script>

<style lang="less" scoped>
.index {
    .sub-logo {
        position: absolute;
        width: 80px;
        top: 20px;
        left: 2px;    
    }
    .sub-logo2 {
        position: absolute;
        width: 40px;
        top: 20px;
        right: 20px;    
    }
    img {
        display: block;
    }
    min-height: 100vh;
    .body {
        padding: 240px 48px 0;
        color: #fff;
        .title {
            display: flex;
            height: 50px;
            align-items: center;
            & + .title {
                border-top: 1px solid #84a3bb;
            }
            .icon {
               width: 59px;
               flex: 0 0 59px;
               margin-right: 12px;
            }
            .title-text {
                font-size: 18px;
                flex: 1;
                line-height: 70px;
            }
            .go {
                width: 10px;
            }
        }
        .boder-bottom {
           border-bottom: 1px solid #84a3bb;
        }
        .indexSwipe {
          .wenJuan {
              margin-top: 12px;
              .wenJuanImg {
                  width: 100%;
              }
              .wenJuanImg3 {
                  width: 100%;
              }
          }
           .wenJuanImg3 {
                  //width: 100%;
                  width: 280px;
            }
        }
    }
    .var_popup{
      .privacy {
        width: calc(100% - 40px);
        border-radius: 4px;
        .title{
          margin-top: 20px;
          margin-bottom: 28px;
          font-size: 20px;
          text-align: center;
          height: 20px;
          line-height: 20px;
          color: #028fe1;
        }
        .content{
          font-size: 16px;
          line-height: 24px;
          height: 280px;
          position: relative;
          overflow: hidden;
          margin: 0 20px;
          word-break: break-all;
          .contentInner {
              position: absolute;
              left: 0;
              top: 0;
              // right: -17px;
              bottom: 0;
              overflow-x: hidden;
              overflow-y: scroll;
              white-space: pre-line;
          }
        }
        .agree {
          font-size: 12px;
          
        }
        .bottom {
            margin-top: 20px;
            margin-bottom: 12px; 
            .van-checkbox__label {
              color: #028fe1 !important;
              font-size: 16px;
            }
            .van-checkbox__icon--checked .van-icon {
              border-radius: 4px;
              background-color: transparent;
              color: #028fe1 !important;
            }
            .cancel, .confirm {
              width: 110px;
              height: 50px;
              border-radius: 8px;
              font-size: 16px;
              border: none;
            }
            .confirm {
              background-color: #0090e2;
            }
            .cancel {
              background-color: #d2d2d2;
            }
            
        }
    }
     .statement {
        width: calc(100% - 40px);
        border-radius: 4px;
        .title {
          width: 100%;
          margin-bottom: 24px;
        }
        .content{
          font-size: 16px;
          line-height: 24px;
          height: 280px;
          position: relative;
          overflow: hidden;
          margin: 0 20px;
          word-break: break-all;
          .contentInner {
              position: absolute;
              left: 0;
              top: 0;
              // right: -17px;
              bottom: 0;
              overflow-x: hidden;
              overflow-y: scroll;
          }
        }

        .bottom {
           display: flex;
           position: relative;
          .goLine {
            width: 60%;
            flex: 0 0 60%;
            margin-left: 10%;
            // width: 60%;
            height: 1px;
            border-top: solid #33b0e6 1px;
            margin-bottom: 24px;
          }
          .go {
            width: 100px;
            position: absolute;
            right: 0;
            bottom: 8px;
            margin-right: 4%;
        }
        }
    }
    .choose {
        width: 90%;
        .content {
          margin-bottom: 12px;
            .cancel {
              width: 80px;
            }
            .confirm {
              width: 80px;
            }
        }
    }
    .registered , .login, .choose{
        width: calc(100% - 40px);
        border-radius: 4px;
        box-sizing: border-box;
        padding: 0 20px;
        .title{
          margin-top: 20px;
          margin-bottom: 28px;
          font-size: 20px;
          text-align: center;
          height: 20px;
          line-height: 20px;
          color: #028fe1;
        }
        .van-cell {
          align-items: center;
          border-bottom: 1px solid #dcdcdc;
          font-size: 14px;
          margin-top: 10px;
        }
        .bottom {
            margin-top: 30px;
            margin-bottom: 30px;
            .confirm {
              width: 200px;
              height: 50px;
              border-radius: 4px;
              font-size: 18px;
            }
        }
    }
    .login {
        width: 90%;
        .title{
          margin-top: 12px;
          font-size: 24px;
          text-align: center;
          height: 24px;
          line-height: 24px;
        }
        .bottom {
            margin-bottom: 12px;
            .confirm {
              width: 120px;
            }
        }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Index2.vue